import React from 'react';
import * as Sentry from '@sentry/react';

const FallbackUI = () => (
    <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: '2rem',
        textAlign: 'center'
    }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>Something went wrong</div>
        <p style={{ color: '#6b7280', marginBottom: '1.5rem', maxWidth: '400px' }}>
            An unexpected error occurred. Please try refreshing the page.
        </p>
        <button
            onClick={() => window.location.reload()}
            style={{
                padding: '0.75rem 2rem',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '0.5rem',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: 'pointer'
            }}
        >
            Refresh Page
        </button>
    </div>
);

const ErrorBoundary = ({ children }) => (
    <Sentry.ErrorBoundary fallback={<FallbackUI />} showDialog={false}>
        {children}
    </Sentry.ErrorBoundary>
);

export default ErrorBoundary;
